/*
 * Readers for the ahooks-serialized values in Web Storage. ahooks'
 * useLocalStorageState / useSessionStorageState JSON-stringify everything they
 * write, so any code reading those keys directly must JSON.parse and must
 * tolerate a corrupt entry — an uncaught throw here takes down whatever called
 * it (sign-in, session-touch, Sentry's user context). One implementation, so
 * the parse contract cannot drift between readers.
 */

function readStored(storage: Storage, key: string): unknown {
  try {
    const raw = storage.getItem(key);
    if (!raw) return undefined;
    return JSON.parse(raw) as unknown;
  } catch {
    return undefined;
  }
}

export function readStoredString(key: string): string | undefined {
  const parsed = readStored(localStorage, key);
  return typeof parsed === 'string' && parsed !== '' ? parsed : undefined;
}

export function readSessionStoredString(key: string): string | undefined {
  const parsed = readStored(sessionStorage, key);
  return typeof parsed === 'string' && parsed !== '' ? parsed : undefined;
}

export function readStoredRecord(
  key: string,
): Record<string, unknown> | undefined {
  const parsed = readStored(localStorage, key);
  return typeof parsed === 'object' && parsed !== null
    ? (parsed as Record<string, unknown>)
    : undefined;
}

export function readStoredNumber(key: string): number | undefined {
  const parsed = readStored(localStorage, key);
  return typeof parsed === 'number' && Number.isFinite(parsed)
    ? parsed
    : undefined;
}
